import { InspectionTypeDetailDTO, InspectionTypeOverviewResponse } from 'src/app/DTOs/InspectionMasterData/InspectionType';import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MasterDataService } from 'src/app/Services/master-data.service';
import { CustomerDTO } from 'src/app/DTOs/CustomerDTO';
import { Router } from '@angular/router';
import { EmptyStateComponent } from 'src/app/Shared/Components/empty-state/empty-state.component';
import { tileRangeLabel } from 'src/app/helper/TileRangeLabel';
import { NotificationService } from 'src/app/Shared/prime-ng/notification.service';
import { DataResult, DataStateChangeEvent, GridDataResult, PageChangeEvent, State, pageSkip, pageTake, process } from 'src/app/Shared/prime-ng/grid-data';
import { PrimeNgModule } from 'src/app/Shared/prime-ng/prime-ng.module';

@Component({
  selector: 'app-inspection-types',
  standalone: true,
  imports: [PrimeNgModule, CommonModule,
    FormsModule,
    EmptyStateComponent
  ],
  templateUrl: './inspection-types.component.html',
  styleUrls: ['./inspection-types.component.css']
})
export class InspectionTypesComponent implements OnInit {
  public gridView: GridDataResult = { data: [], total: 0 };
  public gridState: State = { skip: 0, take: 12 };

  public inspectionTypes: InspectionTypeDetailDTO[] = [];
  public allInspectionTypes: InspectionTypeDetailDTO[] = [];
  public customers: CustomerDTO[] = [];

  public selectedCustomer: CustomerDTO | null = null;
  public loading = false;

  public deleteDialog = false;
  public itemToDelete: InspectionTypeDetailDTO | null = null;
  public activeActionMenuKey: string | null = null;
  get footerRangeLabel(): string {
    return tileRangeLabel(
      this.gridView.total,
      this.gridState.take ?? 12,
      this.gridState.skip ?? 0,
    );
  }

  private deletingItems = new Set<number>();

  constructor(
    private notificationService: NotificationService,
    private masterData: MasterDataService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;

    this.masterData.getInspectionTypeOverview().subscribe({
      next: (response: InspectionTypeOverviewResponse) => {
        this.customers = response.customers;
        this.allInspectionTypes = response.inspectionTypes;

        this.inspectionTypes = [];
        this.selectedCustomer = null;

        this.updateGridView();
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ Error loading data:', err);
        this.notification('Error loading data', 'error');
        this.loading = false;
      }
    });
  }

  private updateGridView(): void {
    this.gridView = process(this.inspectionTypes, this.gridState);
  }

  public pageChange(e: PageChangeEvent): void {    this.gridState.skip = pageSkip(e);
    this.gridState.take = pageTake(e);
    this.updateGridView();
  }
  public toggleActionMenu(item: InspectionTypeDetailDTO, event: MouseEvent): void {    event.stopPropagation();    const menuKey = String(this.getId(item));    this.activeActionMenuKey = this.activeActionMenuKey === menuKey ? null : menuKey;  }  public isActionMenuOpen(item: InspectionTypeDetailDTO): boolean {    return this.activeActionMenuKey === String(this.getId(item));  }  public closeActionMenu(): void {    this.activeActionMenuKey = null;  }
  public onCustomerChange(customer: CustomerDTO | null): void {
    this.selectedCustomer = customer;

    if (!this.selectedCustomer) {
      this.inspectionTypes = [];
    } else {
      this.inspectionTypes = this.allInspectionTypes.filter(
        t => t.customer?.customerId === this.selectedCustomer!.customerId
      );
    }

    this.gridState.skip = 0;
    this.updateGridView();
  }

  public addNew(): void {
    if (!this.selectedCustomer) {
      this.notification('Please select a customer first', 'info');
      return;
    }

    this.router.navigate(['/inspectionTypeDetail', 0], {
      queryParams: { customerId: this.selectedCustomer.customerId }
    });
  }

  public getId(item: InspectionTypeDetailDTO): number {
    const anyItem: any = item as any;
    return (anyItem.auditTypeId ?? item.inspectionTypeId ?? 0) as number;
  }

  public openDetails(item: InspectionTypeDetailDTO): void {
    const id = this.getId(item);

    if (!id || id === 0) {
      this.notification('No valid ID found for this record', 'warning');
      return;
    }

    this.router.navigate(['/inspectionTypeDetail', id]);
  }

  public isDeleting(item: InspectionTypeDetailDTO): boolean {
    return this.deletingItems.has(this.getId(item));
  }

  public openDeleteDialog(item: InspectionTypeDetailDTO): void {
    const id = this.getId(item);

    if (!id || id === 0) {
      this.notification('This record has no valid ID', 'warning');
      return;
    }

    if (this.deletingItems.has(id)) {
      this.notification('Please wait until delete is complete', 'info');
      return;
    }

    this.itemToDelete = item;
    this.deleteDialog = true;
  }

  public toggleDeleteDialog(): void {
    this.deleteDialog = !this.deleteDialog;
    if (!this.deleteDialog) {
      this.itemToDelete = null;
    }
  }

  public confirmDelete(): void {
    if (!this.itemToDelete) {
      this.toggleDeleteDialog();
      return;
    }

    const id = this.getId(this.itemToDelete);

    if (!id || id === 0) {
      this.notification('This record has no valid ID', 'warning');
      this.toggleDeleteDialog();
      return;
    }

    this.deletingItems.add(id);

    this.masterData.deleteInspectionType(id).subscribe({
      next: () => {
        this.allInspectionTypes = this.allInspectionTypes.filter(i => this.getId(i) !== id);
        this.inspectionTypes = this.inspectionTypes.filter(i => this.getId(i) !== id);

        this.updateGridView();
        this.notification('Inspection Type successfully deleted', 'warning');

        this.deletingItems.delete(id);
        this.toggleDeleteDialog();
      },
      error: (err) => {
        console.error('❌ Delete Error:', err);
        this.notification('Error deleting Inspection Type', 'error');

        this.deletingItems.delete(id);
        this.toggleDeleteDialog();
      }
    });
  }

  private notification(message: string, type: 'success' | 'error' | 'warning' | 'info'): void {
    this.notificationService.show({
      content: message,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: type, icon: true }
    });
  }
}
